import React, { useEffect, useState } from 'react';
import { db } from '../../../firebase';
import firebase from 'firebase';
import { useParams } from 'react-router-dom';

function FormAddPlaylist(props) {

    const [noti, setNoti] = useState('');
    //List Category list
    const [listCategory, setListCategory] = useState([]);
    const [listCategoryCheckBox, setListCategoryCheckBox] = useState([]);

    //From
    const [avatar, setAvatar] = useState('');
    const [bg_color, setBgColor] = useState('');
    const [nameVi, setNameVi] = useState('');
    const [nameEn, setNameEn] = useState('');
    const [subTitleVi, setSubTitleVi] = useState('V-Pop đã đơm hoa trên những khúc ca này');
    const [subTitleEn, setSubTitleEn] = useState('V-Pop blossoms on these songs');
    const [keyPass, setKeyPass] = useState('');

    //Load Category
    useEffect(() => {
        db.collection('categories').get().then(async (querySnapshot) => {
            await setListCategory(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        }).catch((error) => {
            console.log({ error })
        });
    }, []);

    //Action Add Song
    const handleClickAddCategory = () => {
        if (keyPass.trim() !== process.env.REACT_APP_PASS_ADD ) {
            setNoti("Dont match keyPass");
            return;
        }
        if (avatar.trim() !== '' && nameVi.trim() !== '' && nameEn.trim() !== '' && subTitleVi.trim() !== '' && subTitleEn.trim() !== '') {
            let data = {
                avatar: avatar,
                bg_color: bg_color,
                list_song_id: [],
                name_vi: nameVi,
                name_en: nameEn,
                subtitle_vi: subTitleVi,
                subtitle_en: subTitleEn,
                hot: true,
                status: true,
                created_at: firebase.firestore.Timestamp.now(),
                updated_at: firebase.firestore.Timestamp.now(),
                key: ''
            };
            db.collection("playlists").add(data)
                .then(function (docRef) {
                    setNoti(`"Document written with ID: " ${docRef.id}`);
                    setAvatar('');
                    setNameVi('');
                    setNameEn('');
                    setBgColor('');
                    db.collection("playlists").doc(docRef.id).update({
                        key: docRef.id,
                        updated_at: firebase.firestore.Timestamp.now()
                    });
                    if (listCategoryCheckBox.length > 0) {
                        listCategoryCheckBox.map(async (item) => {
                            let listPlaylistInCategories = [];
                            await db.collection("categories").doc(item).get().then((doc) => { listPlaylistInCategories = doc.data()['playlists_id'] }).catch((error) => { console.log({ error }) })
                            await db.collection("categories").doc(item).update({
                                playlists_id: [...listPlaylistInCategories, docRef.id],
                                updated_at: firebase.firestore.Timestamp.now()
                            });
                        });
                    }
                })
                .catch(function (error) {
                    setNoti("Error adding document");
                    // console.error("Error adding document: ", error);
                });
        } else {
            setNoti("Dont input text dont null");
        }
    };

    //Action add playlist to song
    const handleChangeCheckBox = (event) => {
        const target = event.target;
        let value = target.value;
        let listCategoryCheckBoxtNew = [];
        if (target.checked) {
            listCategoryCheckBoxtNew = [...listCategoryCheckBox, value];
            setListCategoryCheckBox(listCategoryCheckBoxtNew);
        } else {
            listCategoryCheckBoxtNew = listCategoryCheckBox.filter(function (item) {
                return item !== value;
            });
            setListCategoryCheckBox(listCategoryCheckBoxtNew);
        }
    };


    return (
        <div className="form-add-song" style={{ color: '#fff', margin: '10px auto', display: 'flex', flexDirection: 'row', width: "100%", maxWidth: '900px', flexWrap: 'wrap' }}>
            <div style={{ color: '#fff', margin: '10px auto', display: 'flex', flexDirection: 'column', width: "55%", flexWrap: 'wrap', paddingRight: "5%" }}>
                <label style={{ color: 'purple', fontSize: '12px', textAlign: 'center' }}>{noti}</label>
                <label style={{ color: '#fff', marginRight: ' 10px', width: '100px', marginTop: '8px' }}>Avatar:</label>
                <input autoComplete="off" type="text" name="avatar" value={avatar} onChange={(e) => { setAvatar(e.target.value) }} />

                <label style={{ color: '#fff', marginRight: ' 10px', width: '100px', marginTop: '8px' }}>Bg Color:</label>
                <input autoComplete="off" type="text" name="bg_color" value={bg_color} onChange={(e) => { setBgColor(e.target.value) }} />

                <label style={{ color: '#fff', marginRight: ' 10px', width: '100px', marginTop: '8px' }}>Name VI:</label>
                <input autoComplete="off" type="text" name="name_vi" value={nameVi} onChange={(e) => { setNameVi(e.target.value) }} />

                <label style={{ color: '#fff', marginRight: ' 10px', width: '100px', marginTop: '8px' }}>Name EN:</label>
                <input autoComplete="off" type="text" name="name_en" value={nameEn} onChange={(e) => { setNameEn(e.target.value) }} />

                <label style={{ color: '#fff', marginRight: ' 10px', width: '100px', marginTop: '8px' }}>Subtitle VI:</label>
                <input autoComplete="off" type="text" name="subtitle_vi" value={subTitleVi} onChange={(e) => { setSubTitleVi(e.target.value) }} />

                <label style={{ color: '#fff', marginRight: ' 10px', width: '100px', marginTop: '8px' }}>Subtitle EN:</label>
                <input autoComplete="off" type="text" name="subtitle_en" value={subTitleEn} onChange={(e) => { setSubTitleEn(e.target.value) }} />

                <label style={{ color: '#fff', marginRight: ' 10px', width: '100px', marginTop: '8px' }}>KeyPass:</label>
                <input autoComplete="off" type="password" name="key_pass" value={keyPass} onChange={(e) => { setKeyPass(e.target.value) }} />

                <br />
                <button onClick={handleClickAddCategory} style={{ color: '#fff', width: '100%', margin: '10px 0px', padding: '10px 20px', background: 'purple' }}>Thêm mới Playlist</button>

            </div>
            <div style={{ color: '#fff', margin: '10px auto', display: 'flex', flexDirection: 'column', width: "40%", overflowY: 'scroll', maxHeight: '80vh' }}>
                <label style={{ color: '#fff', marginRight: ' 10px', color: 'purple', width: '300px', marginTop: '8px', marginBottom: '10px' }}> Playlist of Category:</label>
                {
                    listCategory.length > 0 && listCategory.map((item, index) => (
                        <label key={index} style={{ marginBottom: '8px', cursor: 'pointer' }}> <input type="checkbox" value={item.id} onChange={handleChangeCheckBox} /> {item.name_vi} </label>
                    ))
                }
                <br />
            </div>


        </div>
    );
}

export default FormAddPlaylist;